(function() {
  const setupLazyLoading = function() {
    const checkForLazyLoadedImages = function() {
      const $lazyLoadImages = document.querySelectorAll('[hh-load]');
      if (!$lazyLoadImages.length) { return; }

      $lazyLoadImages.forEach(async ($lazyLoad) => {
        if ($lazyLoad.hasAttribute('loaded')) { return; }

        if ($lazyLoad.complete) {
          await new Promise(r => setTimeout(r, 100));

          $lazyLoad.setAttribute('loaded', true);
        } else {
          $lazyLoad.onload = function() {
            $lazyLoad.setAttribute('loaded', true);
          }
        }
      });
    };

    checkForLazyLoadedImages();
    document.addEventListener('variant:info-updated', checkForLazyLoadedImages);
    document.addEventListener('product-cards:loaded', checkForLazyLoadedImages);
    document.addEventListener('search:predicted', checkForLazyLoadedImages);
  };

  document.addEventListener('DOMContentLoaded', () => {
    const $body = document.body;

    const setupScrollLock = function() {
      let _windowPosition = window.scrollY;

      const setupBrowserScrollbarWidth = function() {
        // Get the scrollbar width
        const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        $body.style.setProperty('--scrollbarWidth', `${scrollbarWidth}px`);
      }();

      const restoreScroll = function() {
        $body.style.top = '';
        $body.classList.remove('locked');

        // reset the window y position to where it was
        // when the menu was opened
        window.scroll(0, _windowPosition);
      };

      const preventScroll = async function() {
        _windowPosition = window.scrollY;

        $body.classList.add('locked');
        $body.style.top = `-${_windowPosition}px`;
      };

      document.addEventListener('prevent-scroll', preventScroll);
      document.addEventListener('restore-scroll', restoreScroll);
    }();

    const setupVideoPlayBack = function() {
      const $videos = document.querySelectorAll('[hh-moving-image]');
      if (!$videos.length) { return; }

      $videos.forEach(($video) => {
        const videoUrl = $video.dataset.url;
        if (!videoUrl) { return; }

        const $videoEl = document.createElement('video');

        $videoEl.src = videoUrl;
        $videoEl.load();
        $videoEl.autoplay = true;
        $videoEl.playsInline = true;
        $videoEl.controls = false;
        $videoEl.loop = true;
        $videoEl.muted = true;
        $videoEl.preload = 'auto';

        $video.appendChild($videoEl);
        $video.setAttribute('loaded', true);

        const hideVideo = function() {
          $video.style.setProperty('display', 'none');
        };

        $videoEl.addEventListener('abort', hideVideo);
        $videoEl.addEventListener('error', hideVideo);
      });
    }();

    const setupFormLabels = function() {
      const $formFields = document.querySelectorAll('[has-label]');
      if (!$formFields.length) { return; }

      // trigger form labels
      $formFields.forEach(($formField) => {
        const handleFormLabel = function(e) {
          const $this = e.currentTarget;
          const $fieldBox = $this.parentElement;
          const thisIsFocused = $this === document.activeElement;

          if ($this.value || thisIsFocused) {
            $fieldBox.classList.add('filled');
          } else {
            $fieldBox.classList.remove('filled');
          }
        };

        $formField.addEventListener('blur', handleFormLabel);
        $formField.addEventListener('input', handleFormLabel);
        $formField.addEventListener('focus', handleFormLabel);
      });
    }();

    const setupSearchButtons = function() {
      const $searchButtons = document.querySelectorAll('button[search-button]');
      if(!$searchButtons.length) { return; }

      const triggerSearchOpen = new Event('search:open');

      const dispatchSearchOpenEvent = function () {
        document.dispatchEvent(triggerSearchOpen);
      };

      $searchButtons.forEach(($searchButton) => {
        $searchButton.addEventListener('click', dispatchSearchOpenEvent);
      });
    }();

    const setupResizeListener = function() {
      const bodyResized = new Event('body:resized')
      let windowWidth = window.innerWidth;

      const bodyObserver = new ResizeObserver(() => {
        const newWidth = window.innerWidth;

        if (windowWidth != newWidth) {
          document.dispatchEvent(bodyResized);

          windowWidth = newWidth;
        }
      });

      bodyObserver.observe($body, {box: 'border-box'});
    }();

    // scroll back to last scroll position
    history.scrollRestoration = 'auto';

    // shopify admin refresh
    document.addEventListener('shopify:section:load', () => {
      setupLazyLoading();
    });

    setupLazyLoading();
  });

  const developerSaysHi = function() {
    console.log('%c🐺 coded by | Enrique Ballesté-Peralta | http://enriqueballeste.com 🐺', 'background-color: #F3F6F4; padding: 6px 8px; font-family: monospace; font-size: 14px; color: #231F20; border: 1px solid #231F20; border-radius: 4px;');
  };
  window.addEventListener('load', developerSaysHi);
}());
